import { injectIntl } from 'react-intl';
import React, { PureComponent } from 'react';
import { Button, Grid } from '@mui/material';
import Card from '@mui/material/Card';
import CreateIcon from '@mui/icons-material/Create';
import { formatOnlyNumber, formatOnlyUnit } from '../../../../../../utils/formatNumber';

class QuarterTargetCard extends PureComponent {
  render() {
    const { intl, openModal, quarterTarget, weeklyAppt } = this.props;

    return (
      <Card className="progress-card" id="quarter-card">
        <Grid
          container
          direction="row"
          spacing={0}
          sx={{
            justifyContent: "space-between",
            alignItems: "center"
          }}>
          <Grid className="progress-card-title">
            {intl.formatMessage({ id: 'Quarter Target' })}
          </Grid>
          <Grid className="progress-card-title">
            {intl.formatMessage({ id: 'Weekly Appt' })}
          </Grid>
          <Grid>
            <Button
              color="primary"
              className="edit-button edit-info-button"
              onClick={openModal}
              style={{ float: 'right' }}
            >
              <CreateIcon />
            </Button>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          spacing={0}
          style={{ padding: '10px 0px 8px 0px' }}
          sx={{
            justifyContent: "flex-start",
            alignItems: "center"
          }}>
          <Grid size={6} style={{ color: '#3966f8' }}>
            <span className="progress-card-number">{formatOnlyNumber(quarterTarget, intl)} </span>
            <span className="progress-card-unit">{quarterTarget ? formatOnlyUnit(quarterTarget, intl) : ''}</span>
          </Grid>

          <Grid size={4} className="progress-card-number" style={{ color: '#00000061' }}>
            {weeklyAppt}
          </Grid>
        </Grid>
      </Card>
    );
  }
}

export default injectIntl(QuarterTargetCard);
